import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    headerContainer: {
      display: "flex",
      padding: "10px",
      alignItems: "center",
    },
    body: {
      backgroundColor: "#fff",
      borderRadius: 14,
      height: "70vh",
      marginTop: 20,
      width: "100%",
      [theme.breakpoints.down("xs")]: {
        width: "94%",
      },
    },
    bodyTitle: {
      color: "#1a224b",
      fontSize: 24,
      fontWeight: "bold",
    },
    cancelButtonModal: {
      backgroundColor: "red",
      color: "white",
    },
    searchText: {
      marginLeft: "auto",
      width: 250,
    },
    searchTextAddress: {
      marginLeft: "auto",
      width: 250,
      [theme.breakpoints.down("xs")]: {
        width: "100%",
        marginLeft: "auto",
        display: "grid",
      },
    },
    table: {
      marginTop: 15,
      width: "100%",
    },
    root: {
      backgroundColor: "#f5f6f8",
      display: "flex",
      flexDirection: "row",
      height: "100%",
      width: "100%",
      paddingTop: "60px",
    },
    left: {
      flex: "70%",
      margin: theme.spacing(2),
    },
    right: {
      flex: "30%",
      margin: theme.spacing(0.2),
      backgroundColor: "#fff",
      padding: theme.spacing(2),
    },
    tag: {
      fontFamily: "Montserrat",
      fontSize: 24,
      fontWeight: 300,
      lineHeight: 2.08,
      color: "#757a93",
    },
    headerIcon: {
      textAlign: "right",
    },
    header: {
      backgroundColor: "#fff",
      borderRadius: 14,
      margin: "0px 29px 15px 0",
      justifyContent: "space-between",
      width: "100%",
      display: "flex",
      height: "13.5vh",
      alignItems: "center",
      [theme.breakpoints.down("xs")]: {
        width: "93%",
      },
    },
    footerStyleModal: {
      display: "flex",
      justifyContent: "end",
      width: "100%",
    },
    textDeleteModal: {
      textAlign: "center",
    },
    addButton: {
      width: "180px",
      marginLeft: "10px",
      [theme.breakpoints.down("xs")]: {
        marginTop: "-10px",
      },
    },
  })
);
